import axios from "axios";

export const getCatchReport = async (catchReportID: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/CatchReport/report?CatchReportID=${catchReportID}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
